module.exports = __webpack_public_path__ + "res/22-img_bg_l.67400f7fbf22a79fb93393d5025f7ae9.png";